/* Services.tsx
	Page affichant la gestion des services
	Utilise ServicesCrudCard pour bénéficier de la pagination, du tri et des filtres côté serveur
*/

// Import FontAwesome
import { faHandshake } from '@fortawesome/free-solid-svg-icons';

// Import Feature
import { ServicesCrudCard } from 'features/services';

// Import Layout
import PageHeader from 'layout/PageHeader';

export const Services = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		{/* Titre de page */}
		<PageHeader
			icon={faHandshake}
			title="Services"
			subtitle="Gérez le catalogue de services"
		/>
		<ServicesCrudCard
			size="lg"
			returnPath="/app/settings"
			returnLabel="Paramètres"
			className="mt-6"
		/>
	</div>
);
